module.exports = __webpack_public_path__ + "img/a12710a.png";